<div class="privacy-banner" *ngIf="open$ | async">
  <div class="full-width row mos-u-spacer--padding-bottom-md mos-u-spacer--padding-top-md">
    <div class="columns small-12 medium-10 mos-u-align-center--vertical mos-u-font-weight--medium">
      <div class="privacy-banner-content">
        We use cookies to improve your experience. By using our site, you agree that we can place cookies on your
        device. Please see our<a href="https://www.mercer.com.au/privacy.html" target="_blank">Privacy Notice -
          Australia</a>and<a href="https://www.mercer.co.nz/privacy.html" target="_blank">Privacy Notice - New
          Zealand</a>for details.
      </div>
    </div>
    <div class="columns small-12 medium-2 mos-u-align-right--horizontal">
      <atlas-button class="mos-u-font-weight--thin" [expanded]="false" [size]="'medium'" [style]="'strong'"
        [color]="'brand'" (click)="onPrivacyClick()">
        Ok</atlas-button>
    </div>
  </div>
</div>